// Purchase limits (docs/limits-profit-feedback-receipts-acceptance-criteria.md L7).

export const LIMIT_LABELS: Record<string, string> = {
  PER_PURCHASE_AIRTIME: 'One airtime purchase',
  PER_PURCHASE_DATA: 'One data purchase',
  PER_PURCHASE_CABLE: 'One cable purchase',
  PER_PURCHASE_ELECTRICITY: 'One electricity purchase',
  DAILY: 'Per day',
  MONTHLY: 'Per month',
  NEW_ACCOUNT_DAYS: 'New account: days',
  NEW_ACCOUNT_PER_PURCHASE: 'New account: one purchase',
  NEW_ACCOUNT_DAILY: 'New account: per day',
  NEW_CARD_HOURS: 'New card: hours',
  NEW_CARD_DAILY: 'New card: spend in that time',
  NEW_CARD: 'New card',
};

export const OVERRIDABLE = [
  'PER_PURCHASE_AIRTIME',
  'PER_PURCHASE_DATA',
  'PER_PURCHASE_CABLE',
  'PER_PURCHASE_ELECTRICITY',
  'DAILY',
  'MONTHLY',
];

export interface LimitSettings {
  enabled: boolean;
  values: Record<string, string>;
  file_defaults: Record<string, string>;
  absolute_max: Record<string, string>;
  updated_at: string | null;
  updated_by: string | null;
}

export interface UserLimits {
  per_purchase: Record<string, string>;
  daily: string;
  monthly: string;
  spent_today: string;
  spent_this_month: string;
  new_account_until: string | null;
  new_card_until: string | null;
  new_card_limit: string | null;
  overrides: { id: string; limit_key: string; amount: string; reason: string; expires_at: string | null; created_at: string; revoked_at: string | null; active: boolean }[];
  refusals: { id: string; limit_key: string; limit_amount: string; attempted_amount: string; bill_type: string; source: string; created_at: string }[];
}

export interface RefusalSummary {
  date: string;
  total: number;
  by_key: Record<string, number>;
}

// GET /admin/limits/review (D32): one month, built on the 1st.
export interface LimitsReviewBillType {
  bill_type: string;
  purchases: number;
  p99: string | null;
  largest: string | null;
  limit_key: string;
  limit: string;
  refused: number;
  refused_share_pct: string;
  flag: boolean;
}

export interface LimitsReviewKey {
  limit_key: string;
  limit: string | null;
  refusals: number;
  users: number;
  users_share_pct: string;
  flag: boolean;
}

export interface LimitsReview {
  month: string;
  generated_at: string;
  limits_enabled: boolean;
  active_users: number;
  refusals: number;
  new_account_refusals: number;
  bill_types: LimitsReviewBillType[];
  limit_keys: LimitsReviewKey[];
  flags: string[];
}

export interface LimitsReviewResponse {
  months: string[];
  review: LimitsReview | null;
}
